import { useNavigate } from 'react-router-dom'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Alert, F0Box, TwoColumnLayout } from '@factorialco/f0-react'
import { OneEmptyState } from '@factorialco/f0-react/dist/experimental'
import { Plus } from '@factorialco/f0-react/icons/app'
import { EngagementSurveyOverviewPageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import i18n from 'modules/core/lib/i18n'

import { FormInsightsOverview } from 'modules/engagement_surveys/components/FormInsightsOverview'
import { useSurveyActions } from 'modules/engagement_surveys/hooks/useSurveyActions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { SideContent } from './SideContent'

export default function SurveyOverviewPage() {
  const { surveyId } = useStrictParams<'surveyId'>()
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const { isAdminBecome, isStaffBecome } = useCurrentSession()
  const isBecome = isAdminBecome || isStaffBecome
  const { data, loading, error } = useQuery(EngagementSurveyOverviewPageDocument, {
    variables: { surveyId: String(surveyId) },
  })
  const survey = data?.surveys.survey
  const formId = survey?.form.id.toString() || ''
  const { handleActionClick } = useSurveyActions({ formId })

  if (!survey) return null

  const hasQuestions =
    survey.form.elementsConnection?.totalCount && survey.form.elementsConnection.totalCount > 0

  const showBecomeBanner = isBecome && survey.form.anonymous

  return (
    <ResponsivePage.Body
      loading={loading}
      error={error}
      variant="fullscreen"
      onActionClick={handleActionClick}
    >
      <Box flexGrow height="full">
        <TwoColumnLayout sideContent={<SideContent survey={survey} />}>
          {showBecomeBanner && (
            <F0Box marginBottom="lg">
              <F0Alert
                variant="warning"
                title={i18n.t('surveys.overview.become_anonymous_banner.title')}
                description={i18n.t('surveys.overview.become_anonymous_banner.description')}
              />
            </F0Box>
          )}
          {hasQuestions ? (
            <FormInsightsOverview
              formId={survey.form.id.toString()}
              resourceType="Surveys::Survey"
              persistFilters
              survey={survey}
            />
          ) : (
            <Box justifyContent="center" alignItems="center" height="full">
              <OneEmptyState
                emoji="✏️"
                title={i18n.t('forms.editor.empty_state.title')}
                description={i18n.t('forms.editor.empty_state.description')}
                actions={[
                  {
                    icon: Plus,
                    label: i18n.t('forms.editor.empty_state.button'),
                    onClick: () => {
                      navigate(
                        `${navigation.engagement.smart_surveys.survey.questions.fullPath({
                          surveyId,
                        })}?create=true`
                      )
                    },
                    variant: 'outline',
                  },
                ]}
              />
            </Box>
          )}
        </TwoColumnLayout>
      </Box>
    </ResponsivePage.Body>
  )
}
